const getPosts = "https://column.second-hand.jp/wp-json/wp/v2/posts?_embed&categories=1&per_page=6"

fetch(getPosts).then(
  response => {
    return response.json(); // get JSON data$
  }).then(data => {

for (let i = 0; i < data.length; i++) {
    var date2 = new Date(data[i].date);
    var year = date2.getFullYear();
    var month = date2.getMonth() + 1;
    var day = date2.getDate();
    viewPosts.innerHTML += '<li class="posts">' // contentwrapper
    + '<a href="' + data[i].link + '" class="linkID_' + data[i].id +'">'
    + '<img loading="lazy" src="' + data[i]._embedded["wp:featuredmedia"][0].source_url + '" alt="' + data[i].title.rendered +'">'
   + '<time class="postTime dfont" itemprop="datePublished" datetime="' + data[i].date + '">' + year + '年' + month + '月' + day + '日' + '</time>'
    + '<p class="postTitle">' + data[i].title.rendered + '</p>'
    + '</a>' // href end
    + '</li>' // end content
  }

}).catch(err => {
  // Do something with error here
  console.log('Error: ' + err)
})